interface CampaignIdentityBlockProps {
  campaignName: string;
  role: string;
  locations: string;
}

export default function CampaignIdentityBlock({ campaignName, role, locations }: CampaignIdentityBlockProps) {
  return (
    <div className="flex flex-col items-start">
      <div className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Nunito, sans-serif' }}>
        {campaignName}
      </div>
      <div className="text-xs text-gray-700" style={{ fontSize: '12px', marginTop: '-4px' }}>
        {role} • {locations}
      </div>
    </div>
  );
}

